

















import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { BusinessData } from "@/types";
import AnimatedNumber from "animated-number-vue";

const defaultBackground = "linear-gradient(90deg, #99908B 0%, #3C5E73 100%)";

@Component({
  name: "ThinLineAnimation",

  components: {
    AnimatedNumber
  }
})
export default class FormatServices extends Vue {
  @Prop({ type: Number, required: true }) number!: number;
  @Prop({ type: String, default: defaultBackground }) background!: string;
  @Prop({ type: Number, required: true }) maxValue!: number;
  @Prop({ type: Number, required: false }) totalValue!: number;
  @Prop({ type: Boolean, default: false }) isPercent!:boolean;
  @Ref("number") numberRef: any;

  width: number = 0;

  itemWidth() {
    const stepSize = 40;
    const lineWidth = Math.floor((this.number * 100) / this.maxValue);
    const step = lineWidth / stepSize;

    const interval = () => {
      if (this.width >= Math.floor(lineWidth)) {
        return;
      }

      this.width += step;
      requestAnimationFrame(interval);
    };

    requestAnimationFrame(interval);
  }

  formatToPrice() {
    return this.isPercent ? `${this.number.toFixed(2)}%` : `${((this.number * 100) / (this.totalValue || this.maxValue)).toFixed(2)}%`;
  }

  mounted() {
    this.itemWidth();
  }
}
